<template>
    <div class="bg-light border rounded">
        <div class="d-flex align-items-center p-50" v-on:click="show = !show">
            <div class="d-flex align-items-center g-50">
                <span class="material-icons-outlined text-success" v-if="row.Success">check_circle</span>
                <span class="material-icons-outlined text-danger" v-else>highlight_off</span>
                <b>{{ row.FullName }}</b>
            </div>
            <div class="ml-auto">
                <div v-if="(row.Errors || []).length == 0">
                    <b>N:</b>&nbsp;<span class="text-secondary">{{ $safe(row,'NetStr') }}</span>&nbsp;|&nbsp;<b>B:</b>&nbsp;<span class="text-secondary">{{ $safe(row,'BrutStr') }}</span>
                </div>
            </div>
            <span v-if="!show" class="material-icons-outlined">expand_more</span>
            <span v-else class="material-icons-outlined">expand_less</span>
        </div>
        <b-collapse v-model="show">
            <div class="border-top p-50">
                <div class="bg-light-danger rounded p-75" v-if="(row.Errors || []).length">
                    <h5 class="mb-50 font-weight-bolder text-danger">Hatalar</h5>
                    <ul class="list-group">
                        <li class="list-group-item px-75 p-50" v-for="(e,i) in row.Errors" :key="i">
                            {{ e }}
                        </li>
                    </ul>
                </div>
                <div class="table-responsive mb-0 bg-white" v-if="(row.Errors || []).length == 0">
                    <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th class="w-55">KYKM</th>
                                <th class="w-15">G/S/M</th>
                                <th class="w-15 text-right">Brüt</th>
                                <th class="w-15 text-right">Net</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(e,i) in (row.KYKMValues || [])" :key="i">
                                <td>{{ $safe(e,'Name') }}</td>
                                <td v-b-tooltip.hover.bottom="$safe(e,'KYKMKindName')">{{ $safe(e,'Value') }}</td>
                                <td class="text-right">{{ $safe(e,'BrutStr') }}</td>
                                <td class="text-right">{{ $safe(e,'NetStr') }}</td>
                            </tr>
                            <tr v-if="(row.KYKMValues || []).length == 0">
                                <td colspan="4" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { BCollapse, VBTooltip } from 'bootstrap-vue';
export default {
    components:{
        BCollapse
    },
    data(){
        return {
            show:false
        }
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    props:{
        row:Object,
        field:Object
    },
}
</script>
